// 熱門新聞元件
import Link from 'next/link';
import Image from 'next/image';
import { DEFAULT_IMG } from '@/common/constant';

const TopNewsComponent = ({ info }) => {
    const link = `/${info?.category1}/${info?.slug}`; // 文章連結

    return (
        <Link href={link} prefetch={false} className="flex items-center gap-x-[14px] group">
            {/* 圖片 */}
            <div className="img-box flex-shrink-0 w-[78px] h-[67px] rounded-[4px]">
                <Image
                    className="hover-img"
                    width={78}
                    height={67}
                    src={info?.img || DEFAULT_IMG}
                    alt={info?.alt || '文章摘要'}
                    sizes="50px"
                />
            </div>

            {/* 標題 */}
            <h4 className="text-bd1m text-black2 hover-text group-hover:decoration-white group-hover:text-white line-clamp-2">
                {info?.title}
            </h4>
        </Link>
    );
};

export default TopNewsComponent;
